
import { Component, Vue } from 'vue-property-decorator';
import { engineerTrack } from '@/api/orderService';
import { UserModule } from '@/store/modules/user';
@Component({
  name: 'PathTracking'
})
export default class extends Vue {
  private pheight = window.innerHeight;
  private marker: any = [];

  private selectedData = '';
  private map: any = null;
  private pathSimplifierIns: any = null;
  private getPathData = [
    {
      name: '',
      start: [],
      end: [],
      path: [[]]
    }
  ];
  private pickerOptions = {
    disabledDate(time: any) {
      const _month = new Date().getMonth();
      const _year = new Date().getFullYear();
      let n = 0;
      if (_month === (1 || 3 || 5 || 7 || 8 || 10 || 12)) {
        n = 31;
      } else if (_month === 2) {
        if (
          (_year % 100 === 0 && _year % 400 === 0) ||
          (_year % 100 !== 0 && _year % 4 === 0)
        ) {
          n = 29;
        } else {
          n = 28;
        }
      } else {
        n = 30;
      }
      return time.getTime() < Date.now() - 3600 * 1000 * 24 * n * 8;
    }
  };
  created() {
    this.selectedData = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
    let _this = this;
    AMapUI.load(['ui/misc/PathSimplifier'], function(PathSimplifier: any) {
      if (!PathSimplifier.supportCanvas) {
        _this.$message.error('当前环境不支持 Canvas！');
        return;
      }
      // 启动页面
      _this.initPage(PathSimplifier);
    });
  }
  private initData() {
    let _this = this;
    let data = {
      day: _this.selectedData,
      engineer_id: this.$route.query.user_id,
      company_id: UserModule.getCompanyId,
      engineer_name: this.$route.query.name
    };
    engineerTrack(data)
      .then(res => {
        if (res.data) {
          _this.getPathData = res.data;
          _this.pathSimplifierIns.setData(_this.getPathData);
          if (res.data.path && res.data.path.length > 0) {
            // 创建一个巡航器;
            let navg0 = _this.pathSimplifierIns.createPathNavigator(
              0, // 关联第1条轨迹
              {
                loop: false, // 循环播放
                speed: 1000
              }
            );

            navg0.start();
          }

          _this.getMapMarker(_this.getPathData[0]);
        } else {
          _this.getPathData = [];
          // this.engineerListData = [];
          _this.pathSimplifierIns.setData(_this.getPathData);
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  initPage(PathSimplifier: any) {
    let _this = this;

    _this.map = new AMap.Map('pathContainer', {
      zoom: 4
    });

    // 创建组件实例
    _this.pathSimplifierIns = new PathSimplifier({
      zIndex: 100,
      map: _this.map, // 所属的地图实例
      getPath: function(pathData: any, pathIndex: any) {
        // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
        return pathData.path;
      },
      getHoverTitle: function(pathData: any, pathIndex: any, pointIndex: any) {
        // 返回鼠标悬停时显示的信息
        if (pointIndex >= 0) {
          // 鼠标悬停在某个轨迹节点上
          return pathData.name;
        }
        // 鼠标悬停在节点之间的连线上
        return pathData.name;
      },
      renderOptions: {
        // 轨迹线的样式
        pathLineStyle: {
          lineWidth: 5,
          strokeStyle: '#20BDE5',
          dirArrowStyle: true
        },
        pathLineHoverStyle: {
          lineWidth: 5,
          strokeStyle: '#20BDE5'
        },
        pathLineSelectedStyle: {
          strokeStyle: '#20BDE5',
          lineWidth: 8
        },
        pathNavigatorStyle: {
          fillStyle: 'rgb(32, 189, 229, .5)',
          pathLinePassedStyle: {
            strokeStyle: '#20BDE5'
          }
        }
      }
    });
    _this.initData();
  }
  private getMapMarker(val: any) {
    let _this = this;
    let positions = [];
    let markerHtml = [];
    if (val.start && val.start.length > 0) {
      markerHtml.push(
        '<div class="map-custom-content-marker start">出发</div>'
      );
      positions.push(val.start);
    }

    if (val.signed && val.signed.length > 0) {
      markerHtml.push(
        '<div class="map-custom-content-marker signed">签到</div>'
      );
      positions.push(val.signed);
    }

    if (val.end && val.end.length > 0) {
      markerHtml.push('<div class="map-custom-content-marker end">结束</div>');
      positions.push(val.end);
    }

    for (let m = 0; m < positions.length; m++) {
      _this.marker[m] = new AMap.Marker({
        position: positions[m],
        // 将 html 传给 content
        content: markerHtml[m],
        // 以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-21, -21)
      });

      _this.map.add(_this.marker[m]);
    }
  }
  selectedHandle(val: any) {
    // 选择日期val，得到对应的getPathData数据
    this.selectedData = val;
    this.initData();
    this.map.remove(this.marker);
  }
}
